import { ValueLabel } from "../models/ValueLabel";

export const MESSANGERS_OPTIONS: ValueLabel[] = [
  { value: "ایتا", label: "ایتا" },
  { value: "بله", label: "بله" },
  { value: "واتساپ", label: "واتس‌اپ" },
  { value: "پیامک", label: "پیامک" },
  { value: "تلگرام", label: "تلگرام" },
];
